import React, { ReactElement, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';

import Logout from './components/Atoms/Logout/Logout';
import { Routes } from './enums/routes.enum';
import { getBannerContent } from './store/actions/global.actions';
import { getMe } from './store/actions/user.actions';
import { getLimitations } from './store/actions/limitations.actions';
import { selectUser } from './store/slices/user.slice';
import Login from './views/login/Login';
import AltLogin from './views/alt-login/AltLogin';
import Main from './views/main/Main';
import PasswordValidate from './views/password-validate/PasswordValidate';
import PaymentDetails from './views/payment-details/PaymentDetails';
import ResetPassword from './views/reset-password/ResetPassword';
import Signup from './views/signup/Signup';
import ThankYou from './views/thank-you/ThankYou';

const RedirectToExternalUrl = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.assign(url);
  }, [url]);

  return null;
};

const GuarderRoutes = (): ReactElement => {
  const [isReady, setIsReady] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector(selectUser, shallowEqual);
  const RedirectRoute = 'login';

  useEffect((): void => {
    const getData = async (): Promise<void> => {
      await dispatch(getMe());
      await dispatch(getLimitations());
      await dispatch(getBannerContent());
      setIsReady(true);
    };

    const init = async (): Promise<void> => {
      if (user) {
        setIsReady(true);
        return;
      }
      await getData();
    };

    init().finally();
  }, [user, dispatch]);

  return (
    isReady && (
      <>
        {user ? (
          <Switch>
            <Route path='/thank-you' component={ThankYou} />
            <Route path='/payment-details' component={PaymentDetails} />
            <Route path='/logout' component={Logout} />
            <Main />
            <Route render={(): ReactElement => <Redirect to='/explore' />} />
          </Switch>
        ) : (
          <Redirect to={`/${'login'}${location.search}`} />
        )}
      </>
    )
  );
};

const AppRouting = (): ReactElement => (
  <Router>
    <Switch>
      <Route path='/login' component={Login} />
      <Route path='/alt-login' component={AltLogin} />
      <Route path={Routes.WELCOME} component={Signup} />
      <Route path={Routes.SIGNUP} component={() => <RedirectToExternalUrl url='http://www.musiversal.com' />} />
      <Route path='/reset-password' component={ResetPassword} />
      <Route path='/password/validate/:token' component={PasswordValidate} />
      <Route path='/' component={GuarderRoutes} />
    </Switch>
  </Router>
);

export default AppRouting;
